import React, { useState, useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import './Recorder.css';
import { UploadPhoto } from '../../s3Func/s3Upload';
import Webcam from 'react-webcam';
import { Buffer } from 'buffer';
import countdownSound from './../../PhotoTime/count_down_beep.m4a';
import loading from './../../loading-gif-png-5.gif';
window.Buffer = Buffer;

export default function Recorder(props) {
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const webcamRef = React.useRef(null);
  const audioRef = React.useRef(null);
  const mediaRecorderRef = React.useRef(null);
  const [, forceUpdate] = useState();
  const [capturing, setCapturing] = React.useState(false);
  const [notCapturing, setNotCapturing] = React.useState(false);
  const [recordedChunks, setRecordedChunks] = React.useState([]);
  const [dataUri, setDataUri] = useState('');
  const text = props.outputText;
  const [displayRecorder, setDisplayRecorder] = useState(!props.instruction);
  const [contin, setContin] = useState(false);
  const [pause, setPause] = useState(false);
  const [recordAudio, setRecordAudio] = useState(props.voice);
  const [instructionVideo, setInstructionVideo] = useState(props.instruction);
  const cdSound = new Audio(countdownSound);
  const instructionVideoRef = React.useRef(null);
  const [showStart, setShowStart] = useState(true);
  const [stepPrompt, setStepPrompt] = useState('');
  let timer;
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const confirmIcon = generateImageUrl('images/Module1Images/check_button_small.png')
  const cancelIcon = generateImageUrl('images/Module1Images/x_button.png')
  const playButton = generateImageUrl('images/Images/Video play.png')
  const pauseButton = generateImageUrl('images/Images/pause.png')
  const [Exit, setExit] = useState(generateImageUrl('images/Images/close.png'));
  const [showStep, setShowStep] = useState(false);

  const [waiting, setWaiting] = useState(false);

    const [videoConstraints, setVideoConstraints] = useState({
      width: 391,
      height: 580,
    });

  function isIOS() {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }
  
  function isLandscape() {
    return window.matchMedia("(orientation: landscape)").matches;
  }

  const handleStartCaptureClick = React.useCallback(() => {
    setCapturing(false);
    setNotCapturing(true);
    mediaRecorderRef.current = new MediaRecorder(webcamRef.current.stream, {
      mimeType: isIOS() ? 'video/mp4' : 'video/webm',
    });
    mediaRecorderRef.current.start();
    timer = setTimeout(() => handleStopCaptureClick(), 20000);
  }, [webcamRef, setCapturing, mediaRecorderRef]);

  const handleDataAvailable = React.useCallback(
    ({ data }) => {
      if (data.size > 0) {
        setRecordedChunks((prev) => prev.concat(data));
      }
    },
    [setRecordedChunks]
  );

  const handleStopCaptureClick = React.useCallback(() => {
    mediaRecorderRef.current.stop();
    mediaRecorderRef.current.addEventListener(
      'dataavailable',
      handleDataAvailable
    );
    setCapturing(false);
    setNotCapturing(false);
    setContin(true);
    clearTimeout(timer);
  }, [handleDataAvailable, mediaRecorderRef, setCapturing]);

  function uploadVid() {
    if (recordedChunks.length) {
      const newBlob = new Blob(recordedChunks, {
        type: 'video/mp4',
      });
      const url = URL.createObjectURL(newBlob);
      setRecordedChunks([]);
      return url;
    }
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  useEffect(() => {
    if (displayRecorder) {
      sleep(2000).then(() => {
        setCapturing(true)
      });
    }
  }, []);

  return waiting ? 
  (
    <div
      id='recordpage'
      style={{ backgroundImage: `url(${props.background})` }}
    >
      < img id='loading' src={loading} />
    </div>
  )
  : dataUri ?
  (
    <div
      id='recordpage'
      style={{ backgroundImage: `url(${props.background})` }}
    >
      <img
        alt='back button'
        className='back-btn-ftb'
        src={Exit}
        onClick={() => {
          props.close();
        }}
      ></img>
      <div className='recorder-scroll'>
        <div id='border2'>
          <div className="conversation-topic">{props.title}: {props.subTitle}</div>
          <video className='displayVideo' playsInline>
            <source src={props.instruction} type='video/mp4'></source>
          </video>
          <h4 id='cameraText'>Use this video?</h4>
          <video
            id='record-video'
            autoPlay
            src={dataUri}
            onEnded={() => {
              setPause(false);
              document.getElementById('pauseButton').src = playButton;
            }}
            onError={() => {
              setPause(false);
              document.getElementById('pauseButton').src = pauseButton;
            }}
            playsInline
          />
          <img
            alt='cancel button'
            className='cancel'
            style={{
              width: '75px',
              height: '75px',
              cursor: 'pointer',
            }}
            src={cancelIcon}
            onClick={() => {
              setDataUri(null);
              sleep(2000).then(() => {
                setCapturing(true)
              });
              setContin(false);
              setNotCapturing(false);
              forceUpdate();
            }}
          />
          <img
            alt='pause button'
            id='pauseButton'
            style={{
              left: '50%',
              marginLeft: '-37.5px',
              position: 'absolute',
              bottom: '1vh',
              width: '75px',
              height: '75px',
              cursor: 'pointer',
            }}
            src={playButton}
            onClick={() => {
              if (pause) {
                document.getElementById('record-video').pause();
                document.getElementById('pauseButton').src = playButton;
                setPause(!pause);
              } else {
                document.getElementById('record-video').play();
                document.getElementById('pauseButton').src = pauseButton;
                setPause(!pause);
              }
            }}
          />
          <img
            alt='confirm button'
            className='confirm'
            style={{
              width: '75px',
              height: '75px',
              marginLeft: '-37.5px',
              cursor: 'pointer',
            }}
            src={confirmIcon}
            onClick={() => {
              setWaiting(true);
              if(props.videos){
                props.videos.push(dataUri);
                props.setVideos(props.videos)
              }
              props.ended();
              UploadPhoto(dataUri, 'userfiles', props.name, 'video/mp4', login.studentid);
            }}
          />
        </div>
      </div>
    </div>
  ) : (
    <>
      <div
        id='recordpage'
        style={{ backgroundImage: `url(${props.background})` }}
      >
        <img
          alt='back button'
          className='back-btn-ftb'
          src={Exit}
          onClick={() => {
            props.close(false);
          }}
        ></img>
        <div className='recorder-scroll'>
          {!displayRecorder && (
            <div id='border2'>
              {/* {showStart && isIOS() && (
                <Button
                  onClick={() => {
                    const v = instructionVideoRef.current;
                    if (!v) return;
                    v.muted = false;
                    v.play().catch(() => {});
                    setShowStart(false);
                  }}
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 2,
                  }}
                >
                  Start practice
                </Button>
              )} */}
              <div className="conversation-topic">{props.title}: {props.subTitle}</div>
              <video
                id="record-video"
                autoPlay
                preload='auto'
                controls={isIOS() ? showStart : false}
                onPlaying={() => {
                  setShowStart(false);
                }}
                onEnded={() => {
                  setDisplayRecorder(true);
                  if(props.stepPrompt){
                    //check if stepPrompt is an array
                    if(Array.isArray(props.stepPrompt)){
                      //pop the first element
                      setStepPrompt(props.stepPrompt.shift());
                    }
                    else{
                      setStepPrompt(props.stepPrompt);
                    }
                    setShowStep(true);
                  }
                  else{
                    setInstructionVideo('');
                    sleep(2000).then(() => {
                      setCapturing(true)
                    })
                  }
                }}
                onError={() => {
                  setDisplayRecorder(true);
                  if(props.stepPrompt){
                    setShowStep(true);
                  }
                  else{
                    sleep(2000).then(() => {
                      setCapturing(true)
                    })
                  }
                }}
                playsInline
              >
                <source src={instructionVideo} type='video/mp4'></source>
              </video>
            </div>
          )}
          {showStep && (
            <div id='border2'>
              <div className={`recorder-layout`} style={{ backgroundColor: 'rgb(223, 120, 116, 0.9)', padding: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <h4 id='stepText' dangerouslySetInnerHTML={{ __html: stepPrompt }} style={{ whiteSpace: 'pre-line', color: 'white' }}></h4>
              </div>
              <div className="conversation-topic">{props.title}: {props.subTitle}</div>
              <Webcam
                id='record-video'
                audio={true}
                muted
                playsInline
                onUserMediaError={(e) => console.log('Camera Error:', e)}
                videoConstraints={(isIOS() && !isLandscape()) ? {height: 391, width: 580, facingMode: 'user'} : {...videoConstraints, facingMode: 'user'}}
                ref={webcamRef}
              />
              <Button className='continueButton' onClick={() => {
                //check if stepPrompt still has elements
                if(Array.isArray(props.stepPrompt) && props.stepPrompt.length > 0){
                  setStepPrompt(props.stepPrompt.shift());
                }
                else{
                  setShowStep(false);
                  sleep(2000).then(() => {
                    setCapturing(true)
                  })
                }
              }}>Continue</Button>
            </div>
          )}
          {displayRecorder && !showStep && (
            <audio autoPlay ref={audioRef}>
              <source src={recordAudio}></source>
            </audio>
          )}
          {displayRecorder && !showStep && (
            <div id='border2'>
              <div className="conversation-topic">{props.title}: {props.subTitle}</div>
              <video className='displayVideo' playsInline>
                <source src={props.instruction} type='video/mp4'></source>
              </video>
              <h4
                id='cameraText'
              >
                {text}
              </h4>
              <Webcam
                id='record-video'
                audio={true}
                muted
                playsInline
                onUserMediaError={(e) => console.log('Camera Error:', e)}
                videoConstraints={(isIOS() && !isLandscape()) ? {height: 391, width: 580, facingMode: 'user'} : {...videoConstraints, facingMode: 'user'}}
                ref={webcamRef}
              />
              {notCapturing && (
                <button
                  className='stopButton'
                  style={{ backgroundColor: 'rgb(255, 105, 105)' }}
                  onClick={() => {
                    handleStopCaptureClick();
                  }}
                ></button>
              )}
              {capturing && (
                <button
                  className='recordButton'
                  onClick={() => {
                    cdSound.play();
                    audioRef.current.pause();
                    setRecordAudio('');
                    sleep(500).then(() => {
                      handleStartCaptureClick();
                    });
                  }}
                ></button>
              )}
              {contin && (
                <Button
                  className='continueButton'
                  onClick={() => {
                    setDataUri(uploadVid());
                  }}
                >
                  Continue
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
